export const projectShareErrors = [
  'Cannot invite yourself',
  'Is not an inviteable member of this workspace',
]

export const documentShareErrors = [
  'Is not an inviteable member of this workspace',
  'Is a member of this workspace and cannot be invited as a Guest',
]
